import React, { useEffect, useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';

// Legal Info Constants
const LEGAL = {
  name: 'MS BORN 2 WIN ACADEMY AND CONSULTANCY PRIVATE LIMITED',
  gstin: '33AAPCM2607M1Z8',
  email: 'wavidev0@gmail.com',
  address: 'Second Floor, 18E, Muthu Bharathi Street, Desurpettai Road, Krishnapuram, Gingee, Viluppuram, Tamil Nadu – 604202',
  phone: '+91 95004 39497',
};

// ── Contact Page ──────────────────────────────────────────────────────────────
const ContactPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 pt-28 pb-20 px-4">
    <div className="max-w-3xl mx-auto">
      <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/20 border border-purple-500/30 rounded-full mb-6">
        <div className="w-2 h-2 bg-purple-400 rounded-full animate-pulse"></div>
        <span className="text-purple-300 font-semibold text-sm">Get In Touch</span>
      </div>
      <h1 className="text-4xl sm:text-5xl font-black text-white mb-4">Contact <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Us</span></h1>
      <p className="text-gray-400 mb-10 text-lg">We'd love to hear from you. Reach out through any of the channels below.</p>

      <div className="grid sm:grid-cols-2 gap-6 mb-10">
        {[
          { label: 'Email', value: LEGAL.email, href: `mailto:${LEGAL.email}`, icon: '✉️' },
          { label: 'Phone', value: LEGAL.phone, href: `tel:+919500439497`, icon: '📞' },
          { label: 'WhatsApp', value: 'Chat with us', href: 'https://wa.me/919500439497', icon: '💬' },
          { label: 'Business Address', value: LEGAL.address, href: null, icon: '📍' },
          { label: 'GSTIN', value: LEGAL.gstin, href: null, icon: '🏛️' },
        ].map((item, i) => (
          <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <div className="text-2xl mb-3">{item.icon}</div>
            <p className="text-gray-400 text-sm mb-1">{item.label}</p>
            {item.href
              ? <a href={item.href} className="text-purple-400 hover:text-purple-300 font-semibold break-all transition-colors">{item.value}</a>
              : <p className="text-white font-medium text-sm leading-relaxed">{item.value}</p>
            }
          </div>
        ))}
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
        <p className="text-gray-400 text-sm mb-1">Legal Business Name</p>
        <p className="text-white font-bold text-lg">{LEGAL.name}</p>
        <p className="text-gray-500 text-xs mt-2">Registered under GST · Certificate issued 28/05/2025 · Jurisdictional Office: Chennai</p>
      </div>

      <div className="mt-8 text-center">
        <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all">
          ← Back to Home
        </Link>
      </div>
    </div>
  </div>
);

// ── Privacy Policy Page ───────────────────────────────────────────────────────
const PrivacyPolicyPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 pt-28 pb-20 px-4">
    <div className="max-w-3xl mx-auto">
      <h1 className="text-4xl font-black text-white mb-2">Privacy <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Policy</span></h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: 28 May 2025</p>

      <div className="space-y-8 text-gray-300 text-base leading-relaxed">
        <section>
          <h2 className="text-white font-bold text-xl mb-3">1. Who We Are</h2>
          <p>This website is operated by <span className="text-purple-300 font-semibold">{LEGAL.name}</span> (GSTIN: {LEGAL.gstin}), registered at {LEGAL.address}. We operate the WAVI brand providing software development and SaaS services.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">2. Information We Collect</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Contact details you provide (name, email, phone) when you reach out to us.</li>
            <li>Usage data such as pages visited, browser type, and IP address via standard server logs.</li>
            <li>Cookies for analytics and site functionality (no advertising cookies).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">3. How We Use Your Data</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>To respond to your inquiries and provide our services.</li>
            <li>To improve our website and user experience.</li>
            <li>To comply with legal obligations under Indian law.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">4. Data Storage & Security</h2>
          <p>Your data is stored securely on servers within India. We implement industry-standard security measures. We do not sell or rent your personal data to third parties.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">5. WhatsApp & Communication</h2>
          <p>If you contact us via WhatsApp or email, your messages are stored only for the purpose of responding to your query. We do not use your contact details for unsolicited marketing.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">6. Your Rights</h2>
          <p>You may request access to, correction of, or deletion of your personal data by emailing us at <a href={`mailto:${LEGAL.email}`} className="text-purple-400 hover:text-purple-300">{LEGAL.email}</a>.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">7. Contact</h2>
          <p>{LEGAL.name}<br />{LEGAL.address}<br />Email: <a href={`mailto:${LEGAL.email}`} className="text-purple-400 hover:text-purple-300">{LEGAL.email}</a></p>
        </section>
      </div>

      <div className="mt-10 text-center">
        <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all">
          ← Back to Home
        </Link>
      </div>
    </div>
  </div>
);

// ── Terms & Conditions Page ───────────────────────────────────────────────────
const TermsPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 pt-28 pb-20 px-4">
    <div className="max-w-3xl mx-auto">
      <h1 className="text-4xl font-black text-white mb-2">Terms & <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Conditions</span></h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: 28 May 2025</p>

      <div className="space-y-8 text-gray-300 text-base leading-relaxed">
        <section>
          <h2 className="text-white font-bold text-xl mb-3">1. Acceptance of Terms</h2>
          <p>By accessing or using wavidev.com, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use this website. This site is operated by <span className="text-purple-300 font-semibold">{LEGAL.name}</span>.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">2. Services</h2>
          <p>WAVI provides software development, mobile application development, SaaS products, and related technology services. All service agreements are subject to separate written contracts.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">3. Intellectual Property</h2>
          <p>All content on this website including text, graphics, logos, and code is the property of {LEGAL.name} and is protected under applicable Indian intellectual property laws. You may not reproduce or distribute any content without prior written permission.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">4. User Conduct</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>You must not use this website for any unlawful purpose.</li>
            <li>You must not attempt to gain unauthorised access to any part of the website.</li>
            <li>You must not transmit any harmful, offensive, or disruptive content.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">5. Limitation of Liability</h2>
          <p>WAVI shall not be liable for any indirect, incidental, or consequential damages arising from the use of this website or our services beyond the scope of a signed service agreement.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">6. Governing Law</h2>
          <p>These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Viluppuram, Tamil Nadu.</p>
        </section>

        <section>
          <h2 className="text-white font-bold text-xl mb-3">7. Contact</h2>
          <p>{LEGAL.name}<br />{LEGAL.address}<br />Email: <a href={`mailto:${LEGAL.email}`} className="text-purple-400 hover:text-purple-300">{LEGAL.email}</a></p>
        </section>
      </div>

      <div className="mt-10 text-center">
        <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all">
          ← Back to Home
        </Link>
      </div>
    </div>
  </div>
);
const PartnershipModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="bg-gradient-to-br from-gray-900 to-black border border-purple-500/30 rounded-2xl p-6 sm:p-8 max-w-2xl w-full relative my-8 max-h-[90vh] overflow-y-auto"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white bg-white/10 rounded-full hover:bg-white/20 transition-all z-10"
          >
            <X size={20} />
          </button>
          
          <div className="text-center mb-6 sm:mb-8">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              Partner With <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">WAVI</span>
            </h3>
            <p className="text-gray-400 text-sm sm:text-base">
              Join our SaaS collaboration program with commission-based partnerships
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
            {[
              { name: "POSHUB", desc: "POS & Billing Solution", commission: "35%" },
              { name: "DUE COLL", desc: "Finance Management", commission: "35%" },
              { name: "Wachati", desc: "WhatsApp Business API", commission: "35%" },
              { name: "Taskra", desc: "ERP & CRM Solution", commission: "35%" }
            ].map((product, index) => (
              <div key={index} className="bg-white/5 border border-white/10 rounded-xl p-4">
                <h4 className="text-white font-bold mb-1 text-sm sm:text-base">{product.name}</h4>
                <p className="text-gray-400 text-xs sm:text-sm mb-2">{product.desc}</p>
                <span className="text-purple-400 font-semibold text-sm">{product.commission} Commission</span>
              </div>
            ))}
          </div>
          
          <div className="text-center">
            <p className="text-gray-400 mb-4 text-sm sm:text-base">Ready to collaborate? Send us an email:</p>
            <a
              href="mailto:partnerships@wavidev.com?subject=SaaS Partnership Collaboration&body=Hi WAVI Team,%0A%0AI'm interested in partnering with you for your SaaS products. Please share more details about the commission-based collaboration program.%0A%0AThank you!"
              className="inline-flex items-center gap-2 px-4 sm:px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-semibold hover:shadow-lg transition-all text-sm sm:text-base"
            >
              <Mail size={18} />
              <span className="break-all">partnerships@wavidev.com</span>
            </a>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  Code, 
  Smartphone, 
  Cloud, 
  Zap, 
  ArrowRight, 
  Menu, 
  X,
  Github,
  Linkedin,
  Twitter,
  Mail,
  Phone,
  MapPin,
  MessageCircle
} from 'lucide-react';

// Floating Particles Background
const ParticlesBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {[...Array(20)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-2 h-2 bg-gradient-to-r from-purple-400/30 to-pink-400/30 rounded-full backdrop-blur-sm"
          animate={{
            x: [0, Math.random() * 200 - 100],
            y: [0, Math.random() * 200 - 100],
            opacity: [0, 0.6, 0],
            scale: [0, 1, 0]
          }}
          transition={{
            duration: Math.random() * 8 + 6,
            repeat: Infinity,
            ease: "easeInOut",
            delay: Math.random() * 5
          }}
          style={{
            left: Math.random() * 100 + '%',
            top: Math.random() * 100 + '%',
          }}
        />
      ))}
    </div>
  );
};

// Navigation Component
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const navHref = (section) => isHome ? `#${section}` : `/#${section}`;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled 
          ? 'bg-black/20 backdrop-blur-2xl border-b border-white/10 shadow-2xl shadow-purple-500/10' 
          : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/">
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <img src="/logo.png" alt="WAVI" className="h-10 w-auto" />
          </motion.div>
          </Link>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-1">
            {['Home', 'Services', 'Products', 'About'].map((item, index) => (
              <motion.a
                key={item}
                href={navHref(item.toLowerCase())}
                className="relative px-4 py-2 text-white/80 hover:text-white font-medium transition-all duration-300 group"
                whileHover={{ y: -2 }}
                whileTap={{ y: 0 }}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <span className="relative z-10">{item}</span>
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-pink-400 group-hover:w-full group-hover:left-0 transition-all duration-300"></div>
              </motion.a>
            ))}
            <motion.div whileHover={{ y: -2 }} whileTap={{ y: 0 }} initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.4 }}>
              <Link to="/contact" className="relative px-4 py-2 text-white/80 hover:text-white font-medium transition-all duration-300 group inline-block">
                <span className="relative z-10">Contact</span>
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </Link>
            </motion.div>
          </div>

          {/* CTA Button */}
          <motion.a
            href="mailto:wavidev0@gmail.com?subject=Project Inquiry&body=Hi WAVI team, I'm interested in discussing a project with you."
            className="hidden md:flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold hover:shadow-lg hover:shadow-purple-500/25 transition-all duration-300 group"
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <span>Get Started</span>
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
          </motion.a>

          {/* Mobile Menu Button */}
          <motion.button
            className="md:hidden relative p-2 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl text-white hover:bg-white/10 transition-all duration-300"
            onClick={() => setIsOpen(!isOpen)}
            whileTap={{ scale: 0.95 }}
          >
            <motion.div
              animate={{ rotate: isOpen ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            >
              {isOpen ? <X size={20} /> : <Menu size={20} />}
            </motion.div>
          </motion.button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="md:hidden bg-black/40 backdrop-blur-2xl border-t border-white/10"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="px-4 py-6 space-y-2">
              {['Home', 'Services', 'Products', 'About'].map((item, index) => (
                <motion.a
                  key={item}
                  href={navHref(item.toLowerCase())}
                  className="block px-4 py-3 text-white/80 hover:text-white hover:bg-white/5 rounded-xl font-medium transition-all duration-300"
                  onClick={() => setIsOpen(false)}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                  whileHover={{ x: 10 }}
                >
                  {item}
                </motion.a>
              ))}
              <Link
                to="/contact"
                className="block px-4 py-3 text-white/80 hover:text-white hover:bg-white/5 rounded-xl font-medium transition-all duration-300"
                onClick={() => setIsOpen(false)}
              >
                Contact
              </Link>
              <motion.a
                href="mailto:wavidev0@gmail.com?subject=Project Inquiry&body=Hi WAVI team, I'm interested in discussing a project with you."
                className="block mt-4 px-4 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold text-center"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.6 }}
                onClick={() => setIsOpen(false)}
              >
                Get Started
              </motion.a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

// Hero Section
const HeroSection = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 150]);
  const [typeIndex, setTypeIndex] = useState(0);
  const [displayed, setDisplayed] = useState('');
  const [deleting, setDeleting] = useState(false);

  const roles = ['Web Applications', 'Mobile Apps', 'SaaS Platforms', 'API Solutions', 'Digital Products'];

  useEffect(() => {
    const current = roles[typeIndex];
    let timeout;
    if (!deleting && displayed.length < current.length) {
      timeout = setTimeout(() => setDisplayed(current.slice(0, displayed.length + 1)), 80);
    } else if (!deleting && displayed.length === current.length) {
      timeout = setTimeout(() => setDeleting(true), 1800);
    } else if (deleting && displayed.length > 0) {
      timeout = setTimeout(() => setDisplayed(current.slice(0, displayed.length - 1)), 40);
    } else if (deleting && displayed.length === 0) {
      setDeleting(false);
      setTypeIndex((i) => (i + 1) % roles.length);
    }
    return () => clearTimeout(timeout);
  }, [displayed, deleting, typeIndex]);

  return (
    <section id="home" className="min-h-screen relative overflow-hidden flex flex-col">
      {/* Aurora background */}
      <div className="absolute inset-0 bg-[#030008]">
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 80% 60% at 50% -10%, rgba(120,40,200,0.45) 0%, transparent 70%)' }} />
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 60% 50% at 80% 80%, rgba(219,39,119,0.2) 0%, transparent 60%)' }} />
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 50% 40% at 10% 70%, rgba(6,182,212,0.15) 0%, transparent 60%)' }} />
      </div>

      {/* Animated grid */}
      <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(rgba(139,92,246,0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(139,92,246,0.07) 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }} />

      {/* Floating orbs */}
      <div className="absolute inset-0 pointer-events-none">
        {[
          { cls: 'top-1/4 left-1/4 w-80 h-80 bg-purple-600/15', dur: 8 },
          { cls: 'bottom-1/4 right-1/4 w-96 h-96 bg-pink-600/10', dur: 10 },
          { cls: 'top-1/3 right-1/3 w-40 h-40 bg-cyan-400/15', dur: 12 },
          { cls: 'bottom-1/3 left-1/3 w-32 h-32 bg-violet-400/20', dur: 14 },
        ].map((o, i) => (
          <motion.div key={i} className={`absolute rounded-full blur-3xl ${o.cls}`}
            animate={{ scale: [1, 1.25, 1], opacity: [0.4, 0.8, 0.4] }}
            transition={{ duration: o.dur, repeat: Infinity, ease: 'easeInOut', delay: i * 1.5 }}
          />
        ))}
      </div>

      {/* Main content — flex-1 so it fills space, scroll indicator stays at bottom */}
      <motion.div className="relative z-10 flex-1 flex items-center w-full px-4 pt-24 pb-10" style={{ y }}>
        <div className="max-w-4xl mx-auto w-full text-center">

          {/* Badge */}
          <motion.div
            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500/15 to-pink-500/15 backdrop-blur-sm border border-purple-500/25 rounded-full mb-10"
            initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }}
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-purple-400"></span>
            </span>
            <span className="text-purple-300 text-xs sm:text-sm font-medium tracking-wide">Transforming Ideas into Reality</span>
          </motion.div>

          {/* Main heading */}
          <motion.h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6 leading-[1.15] tracking-tight"
            initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.1 }}
          >
            <span className="block text-white mb-2">We Build</span>
            <span className="block relative mb-2 min-h-[1.2em]">
              <span className="bg-gradient-to-r from-purple-400 via-fuchsia-400 to-pink-400 bg-clip-text text-transparent">
                {displayed}
              </span>
              <span className="inline-block w-[3px] h-[0.8em] bg-purple-400 ml-1 align-middle animate-pulse" />
            </span>
            <span className="block text-white/75 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light mt-1">
              That Scale &amp; Inspire
            </span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            className="text-base sm:text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto font-light leading-relaxed px-2"
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.3 }}
          >
            We architect{' '}
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent font-semibold">scalable solutions</span>{' '}
            that drive innovation and accelerate business growth
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            className="flex flex-col sm:flex-row gap-3 justify-center items-center"
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.45 }}
          >
            <motion.a
              href="mailto:wavidev0@gmail.com?subject=Project Inquiry&body=Hey WAVI team, I'm interested to start work with you."
              className="group relative w-full sm:w-auto px-7 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold text-sm overflow-hidden inline-flex items-center justify-center gap-2 shadow-lg shadow-purple-500/25"
              whileHover={{ scale: 1.04, y: -2 }} whileTap={{ scale: 0.96 }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-fuchsia-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12" />
              <span className="relative">Start Your Project</span>
              <ArrowRight size={15} className="relative group-hover:translate-x-1 transition-transform" />
            </motion.a>

            <motion.a
              href="#products"
              className="group w-full sm:w-auto px-7 py-3 bg-white/5 backdrop-blur-xl border border-white/15 text-white rounded-xl font-semibold text-sm hover:bg-white/10 hover:border-purple-400/40 transition-all inline-flex items-center justify-center gap-2"
              whileHover={{ scale: 1.04, y: -2 }} whileTap={{ scale: 0.96 }}
            >
              <span>Explore Products</span>
              <div className="w-1.5 h-1.5 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full group-hover:animate-ping" />
            </motion.a>
          </motion.div>
        </div>
      </motion.div>

      {/* Scroll indicator — sits at bottom of flex column, perfectly centered */}
      <div className="relative z-10 flex justify-center pb-8">
        <motion.button
          onClick={() => document.getElementById('who-we-are')?.scrollIntoView({ behavior: 'smooth' })}
          className="flex flex-col items-center gap-1.5 text-gray-500 hover:text-purple-400 transition-colors cursor-pointer"
          animate={{ y: [0, 6, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        >
          <span className="text-[10px] tracking-widest uppercase">Scroll</span>
          <div className="w-5 h-8 border border-white/20 rounded-full flex items-start justify-center pt-1.5">
            <motion.div
              className="w-1 h-2 bg-purple-400 rounded-full"
              animate={{ y: [0, 10, 0], opacity: [1, 0.2, 1] }}
              transition={{ duration: 1.5, repeat: Infinity }}
            />
          </div>
        </motion.button>
      </div>
    </section>
  );
};

// About Us Section
const AboutUsSection = () => {
  return (
    <section id="who-we-are" className="py-12 bg-gradient-to-br from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-purple-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-pink-500/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-6xl mx-auto px-4 relative">
        <motion.div
          className="grid md:grid-cols-2 gap-12 items-center"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {/* Left side - Badge and Title */}
          <div>
            <motion.div
              className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-sm border border-purple-500/30 rounded-full mb-6"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="w-2 h-2 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full animate-pulse"></div>
              <span className="text-purple-300 font-semibold text-sm">Who We Are</span>
            </motion.div>
            
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-6 leading-tight">
              Meet <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">WAVI</span>
            </h2>
          </div>
          
          {/* Right side - Content */}
          <div className="space-y-4">
            <p className="text-gray-300 text-lg leading-relaxed">
              We are a passionate team of developers and innovators dedicated to transforming businesses through cutting-edge technology solutions. With expertise spanning web development, mobile applications, and SaaS platforms, we deliver scalable solutions that drive real business growth.
            </p>
            
            <p className="text-gray-300 text-lg leading-relaxed">
              Our commitment to excellence and client success has made us a trusted partner for businesses looking to thrive in the digital landscape. We don't just build software – we craft digital experiences that make a difference.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

// Clients Section
const ClientsSection = () => {
  const [showWorkModal, setShowWorkModal] = useState(false);
  const [showProjectsModal, setShowProjectsModal] = useState(false);
  
  const clients = [
    { name: "OHRI Index", website: "ohriindex.com", industry: "Technology", project: "Business Platform", tech: "React, Node.js, MongoDB", duration: "4 months" },
    { name: "College Connecting", website: "collegeconnecting.com", industry: "Education", project: "Educational Platform", tech: "Vue.js, Python, PostgreSQL", duration: "3 months" },
    { name: "Alpha TD", website: "alphatd.in", industry: "Finance", project: "Trading Platform", tech: "React Native, Firebase", duration: "5 months" },
    { name: "Harv Analytics", website: "harvmanalytics.com", industry: "Analytics", project: "Data Analytics Platform", tech: "Angular, .NET, SQL Server", duration: "6 months" },
    { name: "MS Born2Win Academy", website: "msborn2winac.com", industry: "Education", project: "Learning Management System", tech: "React, Express, MySQL", duration: "4 months" },
    { name: "Niazaf", website: "niazaf.com", industry: "E-commerce", project: "E-commerce Platform", tech: "Next.js, GraphQL, MongoDB", duration: "5 months" },
    { name: "Ocean Gate Services", website: "oceangateservices.com", industry: "Services", project: "Service Management App", tech: "Flutter, Laravel, MySQL", duration: "3 months" },
    { name: "Pebboo", website: "pebboo.com", industry: "Technology", project: "Business Solution", tech: "React, Node.js, Redis", duration: "4 months" }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 relative">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <motion.div
            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-sm border border-purple-500/30 rounded-full mb-6"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="w-2 h-2 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full animate-pulse"></div>
            <span className="text-purple-300 font-semibold text-sm">Our Success Stories</span>
          </motion.div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4 leading-tight">
            Trusted by <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">Amazing Clients</span>
          </h2>
        </motion.div>

        {/* Sliding Client Cards */}
        <div className="relative overflow-hidden">
          <motion.div
            className="flex gap-6"
            animate={{ x: ["-100%", "0%"] }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          >
            {[...clients, ...clients].map((client, index) => (
              <motion.div
                key={index}
                className="flex-shrink-0 w-80 bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-xl border border-white/10 rounded-2xl p-6 hover:border-purple-400/30 transition-all"
                whileHover={{ y: -5, scale: 1.02 }}
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">{client.name[0]}</span>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-white font-bold text-lg mb-1 truncate">{client.name}</h3>
                    <p className="text-gray-400 text-sm mb-2">{client.industry}</p>
                    <div className="text-purple-400 text-sm font-medium truncate">{client.website}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
        
        <motion.div
          className="text-center mt-8 space-y-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            {/* Interactive project showcase button */}
            <motion.button
              onClick={() => setShowProjectsModal(true)}
              className="group relative px-6 py-3 bg-white/5 backdrop-blur-sm border border-white/20 rounded-xl text-white font-medium hover:bg-white/10 hover:border-purple-400/50 transition-all duration-300 overflow-hidden"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative flex items-center gap-2">
                <span>Explore our work</span>
                <div className="w-1 h-1 bg-purple-400 rounded-full group-hover:animate-pulse"></div>
              </div>
            </motion.button>
          </div>
          
          <p className="text-gray-400">
            Ready to join our success stories? 
            <button 
              onClick={() => setShowWorkModal(true)}
              className="text-purple-400 hover:text-purple-300 font-semibold ml-2 transition-colors cursor-pointer"
            >
              Let's work together →
            </button>
          </p>
        </motion.div>
      </div>
      
      {/* Projects Details Modal */}
      <AnimatePresence>
        {showProjectsModal && (
          <motion.div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowProjectsModal(false)}
          >
            <motion.div
              className="bg-gradient-to-br from-gray-900 to-black border border-purple-500/30 rounded-2xl p-6 sm:p-8 max-w-6xl w-full relative my-8 max-h-[90vh] overflow-y-auto"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setShowProjectsModal(false)}
                className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white bg-white/10 rounded-full hover:bg-white/20 transition-all z-10"
              >
                <X size={20} />
              </button>
              
              <div className="text-center mb-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                  Our <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Project Portfolio</span>
                </h3>
                <p className="text-gray-400 text-sm sm:text-base">
                  Detailed overview of our successful client projects and technologies used
                </p>
              </div>
              
              <div className="grid grid-cols-2 gap-4 sm:gap-6">
                {clients.map((client, index) => (
                  <motion.div
                    key={index}
                    className="bg-white/5 border border-white/10 rounded-xl p-4 sm:p-6 hover:border-purple-400/30 transition-all text-center"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                    whileHover={{ y: -5 }}
                  >
                    <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl flex items-center justify-center mx-auto mb-4">
                      <span className="text-white font-bold text-lg">{client.name[0]}</span>
                    </div>
                    
                    <h4 className="text-white font-bold text-sm sm:text-lg mb-2">{client.project}</h4>
                    <p className="text-purple-400 text-xs sm:text-sm font-medium break-all">{client.website}</p>
                  </motion.div>
                ))}
              </div>
              
              <div className="text-center mt-8">
                <p className="text-gray-400 mb-4">Interested in similar results for your project?</p>
                <a
                  href="mailto:wavidev0@gmail.com?subject=Project Portfolio Inquiry&body=Hi WAVI Team,%0A%0AI've reviewed your project portfolio and I'm impressed with your work. I'd like to discuss a similar project for my business.%0A%0AProject Type: [Describe your project]%0AIndustry: [Your industry]%0AExpected Timeline: [Your timeline]%0A%0APlease get back to me with more details.%0A%0AThank you!"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-semibold hover:shadow-lg transition-all"
                  onClick={() => setShowProjectsModal(false)}
                >
                  <Mail size={18} />
                  <span>Discuss My Project</span>
                </a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
      {/* Work Together Modal */}
      <AnimatePresence>
        {showWorkModal && (
          <motion.div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowWorkModal(false)}
          >
            <motion.div
              className="bg-gradient-to-br from-gray-900 to-black border border-purple-500/30 rounded-2xl p-6 sm:p-8 max-w-2xl w-full relative my-8 max-h-[90vh] overflow-y-auto"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setShowWorkModal(false)}
                className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white bg-white/10 rounded-full hover:bg-white/20 transition-all z-10"
              >
                <X size={20} />
              </button>
              
              <div className="text-center mb-6 sm:mb-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                  Why Choose <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">WAVI</span>?
                </h3>
                <p className="text-gray-400 text-sm sm:text-base">
                  Here's what makes us the perfect partner for your next project
                </p>
              </div>
              
              <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
                {[
                  { 
                    title: "Premium Quality Delivery", 
                    desc: "We deliver high-quality, scalable solutions that exceed expectations and drive real business results.",
                    icon: "✨"
                  },
                  { 
                    title: "Proven Track Record", 
                    desc: "3+ years of experience with 20+ successful projects across various industries and technologies.",
                    icon: "🏆"
                  },
                  { 
                    title: "End-to-End Solutions", 
                    desc: "From web development to mobile apps and SaaS platforms - we handle your complete digital transformation.",
                    icon: "🚀"
                  },
                  { 
                    title: "Dedicated Support", 
                    desc: "Our commitment doesn't end at delivery. We provide ongoing support and maintenance for long-term success.",
                    icon: "💪"
                  }
                ].map((point, index) => (
                  <div key={index} className="bg-white/5 border border-white/10 rounded-xl p-4 sm:p-6">
                    <div className="flex items-start gap-4">
                      <div className="text-2xl">{point.icon}</div>
                      <div>
                        <h4 className="text-white font-bold mb-2 text-sm sm:text-base">{point.title}</h4>
                        <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">{point.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="text-center">
                <p className="text-gray-400 mb-4 text-sm sm:text-base">Ready to get started? Send us your project details:</p>
                <a
                  href="mailto:wavidev0@gmail.com?subject=Project Collaboration Inquiry&body=Hi WAVI Team,%0A%0AI'm interested in working with you on my project. Here are the details:%0A%0AProject Type: [Web Development / Mobile App / SaaS / Other]%0AProject Description: [Brief description of your project]%0ABudget Range: [Your budget range]%0ATimeline: [Expected timeline]%0A%0APlease get back to me with more information about how we can collaborate.%0A%0AThank you!"
                  className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-bold hover:shadow-lg transition-all text-sm sm:text-base"
                  onClick={() => setShowWorkModal(false)}
                >
                  <Mail size={18} />
                  <span>Send Project Details</span>
                </a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

// Stats Counter Component
const StatsCounter = ({ end, label }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({ threshold: 0.3 });

  useEffect(() => {
    if (inView) {
      let start = 0;
      const increment = end / 100;
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 20);
      return () => clearInterval(timer);
    }
  }, [inView, end]);

  return (
    <motion.div
      ref={ref}
      className="text-center"
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6 }}
    >
      <div className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
        {count}+
      </div>
      <div className="text-gray-400 mt-2">{label}</div>
    </motion.div>
  );
};

// Services Section
const ServicesSection = () => {
  const services = [
    { 
      icon: Code, 
      title: "Web Development", 
      desc: "Scalable, secure, high-performance web apps built with cutting-edge technologies",
      gradient: "from-blue-500 to-cyan-500"
    },
    { 
      icon: Smartphone, 
      title: "Mobile Apps", 
      desc: "Native Android & iOS applications with stunning UI/UX and seamless performance",
      gradient: "from-green-500 to-emerald-500"
    },
    { 
      icon: Cloud, 
      title: "SaaS Products", 
      desc: "End-to-end SaaS architecture, deployment, and scalable cloud solutions",
      gradient: "from-purple-500 to-pink-500"
    },
    { 
      icon: Zap, 
      title: "API & Automation", 
      desc: "Advanced integrations, AI-powered solutions, and intelligent workflow automation",
      gradient: "from-orange-500 to-red-500"
    },
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-40 h-40 bg-purple-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-32 h-32 bg-pink-500/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 relative">
        <motion.div
          className="text-center mb-20"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <motion.div
            className="inline-block px-6 py-3 bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-sm border border-purple-500/30 rounded-full mb-8"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <span className="text-purple-300 font-semibold">What We Do</span>
          </motion.div>
          
          <h2 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
            Our <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">Services</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Comprehensive technology solutions designed to transform your business and accelerate growth
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="group relative"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-xl border border-white/10 rounded-3xl p-8 h-full hover:border-purple-400/30 transition-all relative overflow-hidden">
                {/* Gradient overlay */}
                <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-10 transition-opacity rounded-3xl`}></div>
                
                <div className={`w-16 h-16 bg-gradient-to-r ${service.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform relative z-10`}>
                  <service.icon className="text-white" size={32} />
                </div>
                <h3 className="text-xl font-bold text-white mb-4 relative z-10">{service.title}</h3>
                <p className="text-gray-400 group-hover:text-gray-300 transition-colors relative z-10">{service.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Products Section
const ProductsSection = () => {
  const products = [
    { name: "POSHUB", desc: "POS web application with mobile app for retail & business billing", url: "https://poshub.in/", color: "from-blue-500 to-cyan-500" },
    { name: "DUE COLL", desc: "Local finance & due collection platform for small finance teams", url: "https://duecoll.in/", color: "from-green-500 to-emerald-500" },
    { name: "Wachati", desc: "WhatsApp Business API platform with Meta integration", url: "https://wachati.com/", color: "from-purple-500 to-pink-500" },
    { name: "Taskra", desc: "All-in-one ERP, CRM, Accounting & HRM solution", url: "http://taskra.app/", color: "from-orange-500 to-red-500" },
  ];

  return (
    <section id="products" className="py-20 bg-gradient-to-br from-purple-900/20 to-black">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl font-bold text-white mb-4">Our Products</h2>
          <p className="text-xl text-gray-400">Innovative SaaS solutions built by our team</p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <motion.div
              key={index}
              className="group relative overflow-hidden rounded-3xl"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${product.color} opacity-20 group-hover:opacity-30 transition-opacity`} />
              <div className="relative bg-black/50 backdrop-blur-sm border border-white/10 p-8 h-full">
                <div className={`w-20 h-20 bg-gradient-to-r ${product.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                  <span className="text-2xl font-bold text-white">{product.name[0]}</span>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{product.name}</h3>
                <p className="text-gray-400 mb-6">{product.desc}</p>
                <motion.a
                  href={product.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-purple-400 hover:text-purple-300 font-semibold"
                  whileHover={{ x: 5 }}
                >
                  Visit Website <ArrowRight size={16} />
                </motion.a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Vision Section
const VisionSection = () => {
  return (
    <section className="py-32 bg-gradient-to-br from-purple-900/20 via-black to-pink-900/20 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-purple-500/10 rounded-full blur-2xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-pink-500/10 rounded-full blur-2xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 relative">
        <motion.div
          className="text-center mb-20"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <motion.div
            className="inline-block px-6 py-3 bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-sm border border-purple-500/30 rounded-full mb-8"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <span className="text-purple-300 font-semibold">Our Vision 2026</span>
          </motion.div>
          
          <h2 className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight">
            Shaping Tomorrow's{' '}
            <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">
              Digital Landscape
            </span>
          </h2>
        </motion.div>

        <motion.div
          className="max-w-6xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-xl border border-white/10 rounded-3xl p-12 md:p-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-purple-500/20 to-transparent rounded-full blur-xl"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-pink-500/20 to-transparent rounded-full blur-xl"></div>
            
            <motion.blockquote 
              className="text-2xl md:text-3xl text-gray-200 leading-relaxed mb-12 text-center font-light relative"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.4 }}
              viewport={{ once: true }}
            >
              By 2026, WAVI will be at the{' '}
              <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent font-semibold">
                forefront of digital innovation
              </span>
              , launching groundbreaking B2C applications and scaling our SaaS ecosystem. We're not just building software – we're{' '}
              <span className="text-white font-semibold">crafting the future of technology</span>{' '}
              with precision, passion, and purpose.
            </motion.blockquote>
            
            <motion.div
              className="grid grid-cols-1 md:grid-cols-3 gap-8"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
            >
              {[
                { title: "Innovation First", desc: "Pioneering next-gen solutions" },
                { title: "Global Impact", desc: "Transforming businesses worldwide" },
                { title: "Future Ready", desc: "Building for tomorrow's challenges" }
              ].map((item, index) => (
                <motion.div 
                  key={index} 
                  className="text-center group"
                  whileHover={{ y: -5 }}
                  transition={{ duration: 0.3 }}
                >
                  <h4 className="text-xl font-bold text-white mb-3 group-hover:text-purple-300 transition-colors">{item.title}</h4>
                  <p className="text-gray-400 group-hover:text-gray-300 transition-colors">{item.desc}</p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

// Team/About Section
const TeamSection = () => {
  const [showPartnerModal, setShowPartnerModal] = useState(false);

  return (
    <>
      <section id="about" className="py-32 bg-black relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-purple-500/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-pink-500/5 rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 relative">
          <motion.div
            className="text-center mb-20"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <motion.div
              className="inline-block px-6 py-3 bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-sm border border-purple-500/30 rounded-full mb-8"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <span className="text-purple-300 font-semibold">Meet Our Team</span>
            </motion.div>
            
            <h2 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
              Elite Team,{' '}
              <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">
                Exceptional Results
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-4xl mx-auto leading-relaxed">
              We are a passionate collective of developers, designers, and innovators united by our commitment to excellence and technological advancement.
            </p>
          </motion.div>

          <motion.div
            className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            {[
              { number: "50+", label: "Projects Delivered" },
              { number: "15+", label: "Happy Clients" },
              { number: "4", label: "SaaS Products" },
              { number: "3+", label: "Years Experience" }
            ].map((stat, index) => (
              <motion.div
                key={index}
                className="text-center group"
                whileHover={{ y: -5 }}
                transition={{ duration: 0.3 }}
              >
                <div className="text-3xl md:text-4xl font-black bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-400 group-hover:text-gray-300 transition-colors">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>

          <motion.div
            className="max-w-5xl mx-auto"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 backdrop-blur-xl border border-white/10 rounded-3xl p-12 md:p-16 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-purple-500/10 to-transparent rounded-full blur-2xl"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-pink-500/10 to-transparent rounded-full blur-2xl"></div>
              
              <div className="text-center relative">
                <motion.h3 
                  className="text-3xl md:text-4xl font-black text-white mb-8"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.6 }}
                  viewport={{ once: true }}
                >
                  Transform Your Vision Into{' '}
                  <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                    Reality
                  </span>
                </motion.h3>
                
                <motion.p 
                  className="text-lg md:text-xl text-gray-300 mb-12 leading-relaxed max-w-4xl mx-auto"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.8 }}
                  viewport={{ once: true }}
                >
                  WAVI stands as a beacon of innovation in the IT landscape. With{' '}
                  <span className="text-white font-semibold">3+ years of proven expertise</span>, we've successfully delivered{' '}
                  <span className="text-white font-semibold">20+ transformative projects</span> across diverse industries. Our mission extends beyond mere development – we{' '}
                  <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent font-semibold">
                    architect scalable SaaS solutions
                  </span>{' '}
                  and pioneering B2C products that define the future of digital interaction.
                </motion.p>
                
                <motion.div
                  className="flex justify-center"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 1 }}
                  viewport={{ once: true }}
                >
                  <motion.button
                    onClick={() => setShowPartnerModal(true)}
                    className="group px-10 py-5 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-2xl font-bold flex items-center justify-center gap-3 hover:shadow-2xl transition-all relative overflow-hidden"
                    whileHover={{ scale: 1.05, boxShadow: "0 25px 50px rgba(168, 85, 247, 0.4)" }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                    <span className="relative">Partner With Us</span>
                    <ArrowRight size={20} className="relative group-hover:translate-x-1 transition-transform" />
                  </motion.button>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      
      <PartnershipModal 
        isOpen={showPartnerModal} 
        onClose={() => setShowPartnerModal(false)} 
      />
    </>
  );
};



// Footer
const Footer = () => {
  return (
    <footer className="relative bg-black border-t border-gray-800/50">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/10 via-black to-pink-900/10"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 py-16">
        {/* Main footer content */}
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand section */}
          <div className="md:col-span-2">
            <motion.div
              className="mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
                className="mb-6"
              >
                <img src="/logo.png" alt="WAVI" className="h-10 w-auto" />
              </motion.div>
              <p className="text-gray-300 text-lg mb-4 leading-relaxed">
                Building <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent font-semibold">Scalable Digital Products</span> for Tomorrow
              </p>
              <div className="inline-block bg-gradient-to-r from-purple-400/20 to-pink-400/20 backdrop-blur-sm border border-purple-400/30 px-4 py-2 rounded-xl">
                <p className="text-purple-300 font-semibold italic">
                  Built with passion & purpose
                </p>
              </div>
            </motion.div>
            
            {/* Social links */}
            <motion.div
              className="flex gap-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              {[
                { Icon: Github, href: "#", color: "hover:bg-gray-700" },
                { Icon: Linkedin, href: "#", color: "hover:bg-blue-600" },
                { Icon: Twitter, href: "#", color: "hover:bg-sky-500" }
              ].map(({ Icon, href, color }, index) => (
                <motion.a
                  key={index}
                  href={href}
                  className={`w-12 h-12 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl flex items-center justify-center text-gray-400 hover:text-white ${color} transition-all group`}
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Icon size={20} className="group-hover:scale-110 transition-transform" />
                </motion.a>
              ))}
            </motion.div>
          </div>
          
          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-white font-bold text-lg mb-6 relative">
              Quick Links
              <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full"></div>
            </h4>
            <div className="space-y-3">
              {['Home', 'Services', 'Products', 'About'].map((link) => (
                <motion.a
                  key={link}
                  href={`#${link.toLowerCase()}`}
                  className="block text-gray-400 hover:text-purple-400 transition-colors group"
                  whileHover={{ x: 5 }}
                >
                  <span className="group-hover:text-white transition-colors">{link}</span>
                </motion.a>
              ))}
              <motion.a
                href="mailto:wavidev0@gmail.com?subject=Contact Inquiry&body=Hi WAVI Team,%0A%0AI would like to get in touch with you regarding:%0A%0A[Please describe your inquiry]%0A%0AThank you!"
                className="block text-gray-400 hover:text-purple-400 transition-colors group"
                whileHover={{ x: 5 }}
              >
                <span className="group-hover:text-white transition-colors">Contact</span>
              </motion.a>
            </div>
          </motion.div>
          
          {/* Products */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h4 className="text-white font-bold text-lg mb-6 relative">
              Our Products
              <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full"></div>
            </h4>
            <div className="space-y-3">
              {[
                { name: 'POSHUB', url: 'https://poshub.in/' },
                { name: 'DUE COLL', url: 'https://duecoll.in/' },
                { name: 'Wachati', url: 'https://wachati.com/' },
                { name: 'Taskra', url: 'http://taskra.app/' }
              ].map((product) => (
                <motion.a
                  key={product.name}
                  href={product.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-gray-400 hover:text-purple-400 transition-colors group"
                  whileHover={{ x: 5 }}
                >
                  <span className="group-hover:text-white transition-colors">{product.name}</span>
                  <ArrowRight size={14} className="inline ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>
        
        {/* Newsletter section */}
        <motion.div
          className="bg-gradient-to-r from-purple-900/20 to-pink-900/20 backdrop-blur-sm border border-white/10 rounded-2xl p-8 mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="text-center max-w-2xl mx-auto">
            <h4 className="text-2xl font-bold text-white mb-4">
              Ready to Start Your Project?
            </h4>
            <p className="text-gray-400 mb-6">
              Let's discuss your ideas and build something amazing together.
            </p>
            <motion.a
              href="mailto:wavidev0@gmail.com?subject=Project Inquiry - Let's Work Together&body=Hey WAVI team,%0A%0AI'm interested to start work with you. I would like to discuss my project requirements.%0A%0APlease get back to me at your earliest convenience.%0A%0AThank you!"
              className="px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold hover:shadow-2xl transition-all inline-block"
              whileHover={{ scale: 1.05, boxShadow: "0 20px 40px rgba(168, 85, 247, 0.4)" }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started Today
            </motion.a>
          </div>
        </motion.div>
        
        {/* Bottom section */}
        <motion.div
          className="border-t border-white/10 pt-8 flex flex-col gap-6"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
        >
          {/* Legal Business Name & Address */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <p className="text-purple-300 font-bold text-sm mb-1 uppercase tracking-wider">Registered Legal Entity</p>
            <p className="text-white font-bold text-base mb-2">MS BORN 2 WIN ACADEMY AND CONSULTANCY PRIVATE LIMITED</p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Second Floor, 18E, Muthu Bharathi Street, Desurpettai Road, Krishnapuram, Gingee,
              Viluppuram, Tamil Nadu – 604202
            </p>
            <p className="text-gray-500 text-xs mt-2">GSTIN: 33AAPCM2607M1Z8 &nbsp;·&nbsp; Email: <a href="mailto:wavidev0@gmail.com" className="text-purple-400 hover:text-purple-300">wavidev0@gmail.com</a></p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-center md:text-left">
              <p>&copy; 2025 MS BORN 2 WIN ACADEMY AND CONSULTANCY PRIVATE LIMITED. All rights reserved.</p>
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-purple-400 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-400 hover:text-purple-400 transition-colors">Terms &amp; Conditions</Link>
              <Link to="/contact" className="text-gray-400 hover:text-purple-400 transition-colors">Contact Us</Link>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

// WhatsApp Float Button
const WhatsAppFloat = () => {
  return (
    <motion.a
      href="https://wa.me/919500439497"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 rounded-full flex items-center justify-center text-white shadow-2xl z-50"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      animate={{ 
        boxShadow: [
          "0 0 0 0 rgba(34, 197, 94, 0.7)",
          "0 0 0 10px rgba(34, 197, 94, 0)",
          "0 0 0 0 rgba(34, 197, 94, 0)"
        ]
      }}
      transition={{ duration: 2, repeat: Infinity }}
    >
      <MessageCircle size={24} />
    </motion.a>
  );
};

// Main App Component
function App() {
  return (
    <Routes>
      <Route path="/" element={
        <div className="bg-black text-white overflow-x-hidden">
          <Navigation />
          <HeroSection />
          <AboutUsSection />
          <ClientsSection />
          <ServicesSection />
          <ProductsSection />
          <VisionSection />
          <TeamSection />
          <Footer />
          <WhatsAppFloat />
        </div>
      } />
      <Route path="/contact" element={<><Navigation /><ContactPage /><Footer /></>} />
      <Route path="/privacy-policy" element={<><Navigation /><PrivacyPolicyPage /><Footer /></>} />
      <Route path="/terms" element={<><Navigation /><TermsPage /><Footer /></>} />
    </Routes>
  );
}

export default App;